// extracted by mini-css-extract-plugin
module.exports = {"media-breakpoint-md":"(min-width: 960px)","mediaBreakpointMd":"(min-width: 960px)","header":"U9_HX9G2 m0 bold","underline":"_1kx26DNj"};